export const PROFESSIONAL_QUALIFICATION_OPTIONS = [
  'Nutritionist',
  'Dietitian',
  'Clinical Nutritionist',
  'Health Coach',
  'Other',
] as const;

